// extracted by mini-css-extract-plugin
module.exports = {"layout":"section-divider_layout__HS8_P","heading":"section-divider_heading__BBq_A"};